export const columns = [
  {
    name: "Email",
    selector: "attributes.email",
    sortable: true,
    sortFunction: (a, b) =>
      a.attributes.created_at_int - b.attributes.created_at_int,
  },
  {
    name: "Name",
    selector: "attributes.full_name",
    sortable: true,
  },
];
